import { css } from '@emotion/react';
import { tokens, applyFont } from '@domain-group/fe-brary';

const { colors, typography } = tokens;

export const enquiryFormPrivacy = css`
  ${applyFont(typography.caption)}
  margin-top: 36px;
  color: ${colors.neutral.heavy.default};
  display: inline-block;
`;

// Tighter, no-top-margin variant for enquiry-modal-2026, which already
// controls its own vertical rhythm via the modal's own section gap.
export const enquiryFormPrivacyCompact = css`
  ${applyFont(typography.mini)}
  color: ${colors.neutral.medium.default};
  display: inline-block;
`;

export const privacyLink = css`
  ${applyFont(typography.caption)}
`;

// Button/LinkButton always apply the pill-button box padding (8px 26px)
// regardless of appearance="link" - zeroed here so this renders as plain
// inline text and doesn't inflate the modal's own trailing spacing.
export const privacyLinkCompact = css`
  ${applyFont(typography.mini)}
  color: ${colors.interactive.base.default};
  padding: 0;
`;

export const privacyLinkModal = css`
  ${applyFont(typography.caption)}
  display: inline;
`;

export const privacyLinkModalCompact = css`
  ${applyFont(typography.caption)}
  color: ${colors.interactive.base.default};
  display: inline;
`;

export const enquiryFormMoreInfo = css`
  ${applyFont(typography.caption)}
`;

export const enquiryFormMoreInfoCompact = css`
  ${applyFont(typography.mini)}
  color: ${colors.interactive.base.default};
  padding: 0;
`;
